import { useEffect } from 'react';
import { analytics } from '../../../firebase';
import { logEvent } from 'firebase/analytics';
import { useLocation } from 'react-router-dom';

export default function TeamLinkUninstallSurvey() {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const installedAt = searchParams.get('installedAt');
    
    let userLifetimeHours = null;
    if (installedAt) {
      const installedAtMs = parseInt(installedAt, 10);
      if (!isNaN(installedAtMs)) {
        userLifetimeHours = (Date.now() - installedAtMs) / 3600000;
      }
    }

    logEvent(analytics, 'uninstall', {
      app: 'teamlink',
      user_lifetime_hours: userLifetimeHours,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }, [location]);

  return (
    <div style={{ margin: '0 auto', textAlign: 'center', backgroundColor: '#f0f2f5', minHeight: '100vh', padding: '20px 0' }}>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdWG2pw5oMP4noU0aGtsv4pd4tpVWFLRizTtu9FA2Yk0LzbTg/viewform?embedded=true"
        width="640"
        height="900"
        style={{ border: 'none', maxWidth: '100%' }}
        title="Teamlink Uninstall Survey"
      >
        Loading...
      </iframe>
    </div>
  );
}
